import React from 'react';
import { createSvgIcon } from '@mui/material';
export default createSvgIcon(React.createElement("path", { d: "M21 2.25H2.99999C1.72499 2.25 0.974989 3.825 1.87499 4.8L9.74999 13.125V21.75H11.25L14.25 18.75V17.25V13.125L22.125 4.725C23.025 3.825 22.275 2.25 21 2.25Z" // eslint-disable-line
 }), 'FilterFilled');
